import { useQuery } from 'react-query';
import { queryKeys } from './queryKeys';
import request from '../../../helpers/request';

const getDocumentTypeList = async () => {
  return await request.get(`/Docs/types`);
};

export const useDocumentTypeListQuery = (options = {}) => {
  return useQuery(queryKeys.documentTypeList(), () => getDocumentTypeList(), {
    placeholderData: [],
    ...options,
  });
};

export default useDocumentTypeListQuery;
